import { capitalize } from '@fergdigitalcommerce/fergy-utilities';
import { useContext } from 'react';
import { AlertNotificationContext, type AlertNotificationType } from '../../contexts/alert-notification.context';

const NOTIFICATION_TYPES: AlertNotificationType[] = ['success', 'info', 'danger', 'warning'];

/**
 * given a notification function returns a reducer for creating a notifier function per notification type
 */
function generateNotifier(showNotification) {
	return (notifiers, notificationType) => {
		notifiers[`notify${capitalize(notificationType)}`] = (message: string | JSX.Element, timeout = 3000, onDismiss?: () => void) => {
			showNotification(message, notificationType, timeout, onDismiss);
		};
		return notifiers;
	};
}

type NotifyFn = (message: string | JSX.Element, timeout?: number, onDismiss?: () => void) => void;

export type Notifiers = {
	notifySuccess: NotifyFn;
	notifyInfo: NotifyFn;
	notifyDanger: NotifyFn;
	notifyWarning: NotifyFn;
};

/**
 * hook meant to simplify triggering of alert notifications
 */
export function useNotification(): Notifiers {
	const { showNotification } = useContext(AlertNotificationContext);
	return NOTIFICATION_TYPES.reduce(generateNotifier(showNotification), {});
}
